const HEADER_HEIGHT = 72;
const DRAWER_WIDTH = 414;


export { HEADER_HEIGHT, DRAWER_WIDTH };
